import React, { useState, useEffect } from 'react';

import logo from '../assets/logo-black.png';

const NavBar = () => {
  const [fixClass, setFix] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const setFixed = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      windowHeight > 100
        ? setFix(true)
        : setFix(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', setFixed);
    return () => {
      window.removeEventListener('scroll', setFixed);
    };
  }, []);

  const navLinks = [
    { href: "#cours", label: "Cours" },
    { href: "#karate", label: "Karaté" },
    { href: "#self", label: "Self-défense" },
    { href: "#contact", label: "Contact" },
    { href: "#price", label: "Prix" },
  ];

  return (
    <header className={`${fixClass ? 'fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-100' : 'absolute top-0 left-0 right-0 z-50'} transition-all duration-300`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          
          {/* Logo */}
          <a href="#hero" className="flex items-center space-x-3 group">
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-r from-primary to-red-600 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
              <img
                src={logo}
                className="relative w-12 h-12 object-cover"
                alt="ECKSD Logo"
              />
            </div>
            <span className="text-2xl font-bold">
              <span className={`${fixClass ? 'text-gray-900' : 'text-white'} transition-colors duration-300`}>EC</span>
              <span className="text-primary">KSD</span>
            </span>
          </a>

          {/* Navigation Desktop */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`relative font-medium transition-all duration-300 hover:scale-105 group ${
                  fixClass 
                    ? 'text-gray-700 hover:text-primary' 
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-primary to-red-600 group-hover:w-full transition-all duration-300"></span>
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="#contact"
              className="inline-flex items-center px-6 py-2.5 bg-gradient-to-r from-primary to-red-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
              Contact & Documents
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors duration-300 ${
              fixClass 
                ? 'text-gray-700 hover:bg-gray-100' 
                : 'text-white hover:bg-white/10'
            }`}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className={`md:hidden border-t py-4 rounded-b-2xl ${
            fixClass 
              ? 'border-gray-200/20 bg-white/95 backdrop-blur-md' 
              : 'border-gray-200/20 bg-white/95 backdrop-blur-md'
          }`}>
            <div className="space-y-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="block py-2 px-4 rounded-lg font-medium transition-all duration-300 text-gray-700 hover:bg-gray-100 hover:text-primary"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setMobileMenuOpen(false)}
                className="block mt-4 mx-4 px-4 py-2 bg-gradient-to-r from-primary to-red-600 text-white font-semibold rounded-full text-center shadow-lg text-sm"
              >
                Contact
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default NavBar;
